import { render } from "./aboutTmbd.vue?vue&type=template&id=9a1b7d54&scoped=true"
import script from "./aboutTmbd.vue?vue&type=script&lang=js"
export * from "./aboutTmbd.vue?vue&type=script&lang=js"

import "./aboutTmbd.vue?vue&type=style&index=0&id=9a1b7d54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a1b7d54"]])

export default __exports__